//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { CalendarColorMode, CalendarViewMode, StudentPortalHomepage } from './Enums';

export class SchoolStudentPortalSettingsUpdateItem extends ItemBase {
    AllowPartialOnlinePayments?: boolean;
    AllowProfileEditing?: boolean;
    CalendarColorMode?: CalendarColorMode;
    InitialCalendarView?: CalendarViewMode;
    InitialView?: StudentPortalHomepage;
    ShowAccountAndInvoices?: boolean;
    ShowMakeupCredits?: boolean;
    ShowStudentAttendeeList?: boolean;
    ShowStudentContactList?: boolean;
    ShowTeacherAddress?: boolean;
    ShowTeacherEmailAndTelephoneNumber?: boolean;

    constructor(initializer?: Partial<SchoolStudentPortalSettingsUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SchoolStudentPortalSettingsUpdateItem";
}
